/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class MenuApi {
    static getInstance() {
        if (!this.instance) this.instance = new MenuApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 菜单列表
    async getMenuList (param,page_num,page_size){
        let url = `/api/sys/menu/list?page_num=${page_num}&page_size=${page_size}`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 菜单下拉数据
    async getMenuSelectList (param){
        let url = `/api/sys/menu/query`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 新增菜单 
    async addMenu (param){
        let url = `/api/sys/menu`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 修改菜单
    async editMenu (param,id){
        let url = `/api/sys/menu/${id}`
        let result = await this.getData(url,param,'PUT')
        return result
    }

    // 删除菜单 
    async deleteMenu (id){
        let url = `/api/sys/menu/${id}`
        let result = await this.getData(url,{},'DELETE')
        return result
    }

    // 获取菜单树形结构数据
    async getMenuTree (param, user_id){
        let url = `/api/sys/menu/level/${user_id}`
        let result = await this.getData(url,param,'POST')
        return result
    }
}

export {
    MenuApi
}